import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'currentTimeZone'
})

export class CurrentTimeZonePipe implements PipeTransform {

    transform(value: any, dateFormat?: any, timeFormat?: any): any {
        if(value){
            let lastCharOfValue = value.charAt(value.length - 1);
            if(lastCharOfValue.toUpperCase() !== 'Z'){
                value = value + 'Z';
            }
            const timeType = timeFormat ? timeFormat : null;
            const dateValue = moment(value).format('MM/DD/YYYY HH:mm:ss');
            const convertedDate = new Date(Date.parse(dateValue));
            if (dateFormat) {
                return (moment(convertedDate).format(dateFormat) + (timeType ? ` ${moment(convertedDate).format(timeType)}` : ''));
            } else {
                return (moment(convertedDate).format('MM/DD/YYYY'));
            }
        }else{
            return null;
        }
    }

}
